module.exports = __webpack_public_path__ + "img/14.d2f43297.png";